const projects = [
  {
    id: "project-1",
    ekranId: "ekran1",
    textureIndex: 1,
    title: "Ball Game",
    shortDescription: "Physics-based 3D game",
    description: "An interactive 3D game built with React Three Fiber and Rapier physics engine. Control a ball, dodge obstacles, and reach the goal. Enhanced with real-time physics simulation and post-processing effects.",
    techStack: ["React Three Fiber", "Rapier Physics", "Zustand", "Designs"],
    liveUrl: "https://unfor-ball-game.vercel.app/",
    sourceUrl: "https://github.com/unfor-dev/Ball-game",
    images: ["/img/img/a2.1.png", "/img/img/a2.2.png", "/img/img/a2.3.png"],
    year: 2026,
    category: "WebGL Game"
  },
  {
    id: "project-2",
    ekranId: "ekran2",
    textureIndex: 18,
    title: "Earth",
    shortDescription: "Interactive 3D Earth",
    description: "A beautiful 3D Earth visualization built with Three.js and GSAP animations. Rotate, zoom, and view from different angles with realistic textures and atmospheric effects.",
    techStack: ["Three.js", "React", "GSAP", "GLSL", "Designs"],
    liveUrl: "https://unfor-earth.vercel.app/",
    sourceUrl: "https://github.com/unfor-dev/3d-earth",
    images: ["/img/img/a3.1.png", "/img/img/a3.2.png", "/img/img/a3.3.png"],
    year: 2026,
    category: "3D Visualization"
  },
  {
    id: "project-3",
    ekranId: "ekran3",
    textureIndex: 3,
    title: "Suzuki Bike",
    shortDescription: "3D motorcycle model",
    description: "A Suzuki motorcycle 3D model built with React Three Fiber. Equipped with smooth camera movement, post-processing effects, and Lenis smooth scroll. View the motorcycle and explore it in detail.",
    techStack: ["React Three Fiber", "GSAP", "Postprocessing", "Shader", "Designs"],
    liveUrl: "https://unfor-3d-bike.vercel.app/",
    sourceUrl: "https://github.com/unfor-dev/3d-bike",
    images: ["/img/img/a4.1.png", "/img/img/a4.2.png", "/img/img/a4.3.png"],
    year: 2025,
    category: "3D Product"
  },
  {
    id: "project-4",
    ekranId: "ekran4",
    textureIndex: 4,
    title: "3D Book",
    shortDescription: "Interactive book slider",
    description: "A 3D book slider built with Jotai state management and React Three Fiber. Flip pages, rotate the book, and zoom in. Features realistic page-curl animations and shadow effects.",
    techStack: ["React Three Fiber", "Maath", "Designs"],
    liveUrl: "https://unfor-3d-book.vercel.app/",
    sourceUrl: "https://github.com/unfor-dev/3D-Book-slider",
    images: ["/img/img/a5.1.png", "/img/img/a5.2.png", "/img/img/a5.3.png"],
    year: 2025,
    category: "3D Interactive"
  },
  {
    id: "project-5",
    ekranId: "ekran5",
    textureIndex: 7,
    title: "Birthday Greetings",
    shortDescription: "3D birthday greeting",
    description: "A stunning birthday greeting animation built with React Three Fiber. Confetti effects, 3D text, and post-processing create a festive atmosphere. Perfect for personalized greetings.",
    techStack: ["React Three Fiber", "Designs"],
    liveUrl: "https://unfor-birthday-greetings.vercel.app/",
    sourceUrl: "https://github.com/unfor-dev/birthday-greetings",
    images: ["/img/img/a8.1.png", "/img/img/a8.2.png", "/img/img/a8.3.png"],
    year: 2025,
    category: "3D Animation"
  },
  {
    id: "project-6",
    ekranId: "ekran6",
    textureIndex: 8,
    title: "Xbox Controller",
    shortDescription: "3D controller model",
    description: "An Xbox controller 3D showcase built with React Three Fiber. Photorealistic rendering with PBR materials, environment lighting, and post-processing effects. Interactive controls and smooth animations.",
    techStack: ["React Three Fiber", "Postprocessing", "Designs"],
    liveUrl: "https://unfor-xbox.vercel.app/",
    sourceUrl: "https://github.com/unfor-dev/xbox-controller",
    images: ["/img/img/a9.1.png", "/img/img/a9.2.png", "/img/img/a9.3.png"],
    year: 2025,
    category: "3D Product"
  },
  {
    id: "project-7",
    ekranId: "ekran7",
    textureIndex: 5,
    title: "Old Art Evil",
    shortDescription: "Ancient art visualization",
    description: "A mystical 3D visualization of ancient art built with Three.js. Unique shader effects, atmospheric lighting, and cinematic camera movements create a mysterious environment.",
    techStack: ["Three.js", "GLSL", "Designs"],
    liveUrl: "https://unfor-old-art-evil.vercel.app/",
    sourceUrl: "https://github.com/unfor-dev/old-art",
    images: ["/img/img/a6.1.png", "/img/img/a6.2.png", "/img/img/a6.3.png"],
    year: 2025,
    category: "3D Art"
  },
  {
    id: "project-8",
    ekranId: "ekran8",
    textureIndex: 6,
    title: "Honey Bee",
    shortDescription: "3D bee animation",
    description: "A natural bee animation built with Three.js and GSAP. Realistic simulation of bee movement, flying around flowers, and collecting honey. Enriched with scroll-based animations.",
    techStack: ["Three.js", "React", "GSAP", "Designs"],
    liveUrl: "https://unfor-honey-bee.vercel.app/",
    sourceUrl: "https://github.com/unfor-dev/Honey-bee",
    images: ["/img/img/a7.1.png", "/img/img/a7.2.png", "/img/img/a7.3.png"],
    year: 2025,
    category: "3D Storytelling"
  },
  {
    id: "project-9",
    ekranId: "ekran9",
    textureIndex: 15,
    title: "Galaxy",
    shortDescription: "Galaxy particle system",
    description: "A galaxy simulation made of 100,000+ particles built with Three.js and lil-gui. Adjust parameters in real-time to create different galaxy shapes and colors. Experience the beauty of the cosmos.",
    techStack: ["Three.js", "GLSL Shaders"],
    liveUrl: "https://unfor-galaxy.vercel.app/",
    sourceUrl: "https://github.com/unfor-dev/Galaxy",
    images: ["/img/img/a16.1.png", "/img/img/a16.2.png", "/img/img/a16.3.png"],
    year: 2025,
    category: "Particle System"
  },
  {
    id: "project-10",
    ekranId: "ekran10",
    textureIndex: 16,
    title: "Ship Particles",
    shortDescription: "Ship particle effect",
    description: "A particle-based ship visualization built with Three.js. Thousands of particles form the ship shape and animate it. Adjust color, size, and speed in real-time via Lil-GUI.",
    techStack: ["Three.js", "GLSL Shaders", "Designs"],
    liveUrl: "https://unfor-ship-particles.vercel.app/",
    sourceUrl: "https://github.com/unfor-dev/Ship-particles",
    images: ["/img/img/a17.1.png", "/img/img/a17.2.png", "/img/img/a17.3.png"],
    year: 2024,
    category: "Particle System"
  },
  {
    id: "project-11",
    ekranId: "ekran11",
    textureIndex: 13,
    title: "Cars Showcase",
    shortDescription: "Tesla car 3D showcase",
    description: "Cars 3D showcase built with React Three Fiber. View different Car models in 360° and explore features. An ideal example for premium car presentations.",
    techStack: ["React Three Fiber", "Designs"],
    liveUrl: "https://unfor-tesla-web.vercel.app/",
    sourceUrl: "https://github.com/unfor-dev/tesla-web",
    images: ["/img/img/a14.1.png", "/img/img/a14.2.png", "/img/img/a14.3.png"],
    year: 2025,
    category: "3D Configurator"
  },
  {
    id: "project-12",
    ekranId: "ekran12",
    textureIndex: 14,
    title: "Raging Sea",
    shortDescription: "Realistic sea shader",
    description: "A realistic ocean simulation built with custom GLSL shaders. Wave movement, foam effects, and color changes based on time of day. Adjust wave height and speed via Lil-GUI.",
    techStack: ["Three.js", "GLSL", "Designs"],
    liveUrl: "https://unfor-raging-sea-shading.vercel.app/",
    sourceUrl: "https://github.com/unfor-dev/Raging-Sea",
    images: ["/img/img/a15.1.png", "/img/img/a15.2.png", "/img/img/a15.3.png"],
    year: 2026,
    category: "Shader Art"
  },
  {
    id: "project-13",
    ekranId: "ekran13",
    textureIndex: 9,
    title: "Brabus & Mercedes",
    shortDescription: "Premium car 3D showcase",
    description: "A Brabus and Mercedes car 3D presentation built with React Three Fiber and GSAP. Cinematic camera movements, scroll-triggered animations, and post-processing effects for a luxurious look.",
    techStack: ["React Three Fiber", "GSAP", "Designs"],
    liveUrl: "https://unfor-mercedes.vercel.app/",
    sourceUrl: "https://github.com/unfor-dev/mercedes",
    images: ["/img/img/a10.1.png", "/img/img/a10.2.png", "/img/img/a10.3.png"],
    year: 2025,
    category: "3D Product"
  },
  {
    id: "project-14",
    ekranId: "ekran14",
    textureIndex: 10,
    title: "Spiderman",
    shortDescription: "3D character animation",
    description: "A Spiderman 3D character built with React Three Fiber and GSAP. Dynamic pose animations, web effects, and cinematic camera movements. A stunning visual experience for superhero fans.",
    techStack: ["React Three Fiber", "GSAP", "Postprocessing", "GLSL", "Designs"],
    liveUrl: "https://unfor-spiderman.vercel.app/",
    sourceUrl: "https://github.com/unfor-dev/spiderman-new",
    images: ["/img/img/a11.1.png", "/img/img/a11.2.png", "/img/img/a11.3.png"],
    year: 2025,
    category: "3D Character"
  },
  {
    id: "project-15",
    ekranId: "ekran15",
    textureIndex: 11,
    title: "Wobbly Shader",
    shortDescription: "Custom shader effect",
    description: "A wobbly sphere built with Three.js and Custom Shader Material library. Organic movements based on mathematical formulas and colorful gradient effects. Change shader parameters in real-time with via Lil-GUI",
    techStack: ["Three.js", "GLSL", "Designs"],
    liveUrl: "https://unfor-wobbly-sphere.vercel.app/",
    sourceUrl: "https://github.com/unfor-dev/Wobbly-Sphere",
    images: ["/img/img/a12.1.png", "/img/img/a12.2.png", "/img/img/a12.3.png"],
    year: 2025,
    category: "Shader Art"
  },
  {
    id: "project-16",
    ekranId: "ekran16",
    textureIndex: 12,
    title: "Razer Mouse",
    shortDescription: "Gaming mouse 3D model",
    description: "A Razer gaming mouse 3D showcase built with React Three Fiber. PBR materials, RGB lighting effects, and interactive controls. An ideal 3D presentation example for product pages.",
    techStack: ["React Three Fiber", "GSAP", "Postprocessing", "Designs"],
    liveUrl: "https://unfor-pc-mouse.vercel.app/",
    sourceUrl: "https://github.com/unfor-dev/pc-mouse",
    images: ["/img/img/a13.1.png", "/img/img/a13.2.png", "/img/img/a13.3.png"],
    year: 2025,
    category: "3D Product"
  },
  {
    id: "project-17",
    ekranId: "ekran17",
    textureIndex: 17,
    title: "Mixing Diamond",
    shortDescription: "3D diamond visualization",
    description: "A brilliant diamond 3D model built with React Three Fiber. Reflection, and light dispersion effects. A showcase example for jewelry product presentations.",
    techStack: ["React Three Fiber", "Designs"],
    liveUrl: "https://unfor-models-mix-diamond.vercel.app/",
    sourceUrl: "https://github.com/unfor-dev/models-mix",
    images: ["/img/img/a18.1.png", "/img/img/a18.2.png", "/img/img/a18.3.png"],
    year: 2025,
    category: "3D Material"
  },
  {
    id: "project-18",
    ekranId: "ekran18",
    textureIndex: 0,
    title: "Haunted House",
    shortDescription: "3D haunted house scene",
    description: "An atmospheric haunted house 3D scene built with Three.js. Realistic shadows, fog effects, moonlight, and Eerie lighting. A perfect example for creating Halloween or horror game environments.",
    techStack: ["Three.js", "GLSL", "Designs"],
    liveUrl: "https://unfor-haunted-house.vercel.app/",
    sourceUrl: "https://github.com/unfor-dev/Hounter-house",
    images: ["/img/img/a1.1.png", "/img/img/a1.2.png", "/img/img/a1.3.png"],
    year: 2024,
    category: "3D Scene"
  }
];

/**
 * Proyektni id bo'yicha topish
 * @param {string} id - Proyekt ID
 * @returns {Object|undefined} - Topilgan proyekt yoki undefined
 */
export const getProjectById = (id) => {
  return projects.find(project => project.id === id);
};

/**
 * Proyektni ekranId bo'yicha topish
 * @param {string} ekranId - Ekran ID (masalan: "ekran1")
 * @returns {Object|undefined} - Topilgan proyekt yoki undefined
 */
export const getProjectByEkranId = (ekranId) => {
  return projects.find(project => project.ekranId === ekranId);
};

/**
 * Barcha proyektlarni olish
 * @returns {Array} - Barcha proyektlar ro'yxati
 */
export const getAllProjects = () => projects;

/**
 * Kategoriya bo'yicha proyektlarni filtrlash
 * @param {string} category - Kategoriya nomi
 * @returns {Array} - Filtrlangan proyektlar
 */
export const getProjectsByCategory = (category) => {
  return projects.filter(project => project.category === category);
};

export default projects;
